import { $host } from ".";

export const getPatients = async (phone) => {
  const response = await $host.post("web/user/phone", { phone });
  return response.data.users;
};

export const addPoints = async (id, points, comment) => {
  const data = await $host.post("web/user/addpoints", {
    id,
    points,
    comment,
  });
  return data;
};

export const reducePoints = async (id, points, comment) => {
  const data = await $host.post("web/user/reducepoints", {
    id,
    points,
    comment,
  });
  return data;
};

export const sendMessage = async (id, message) => {
  const data = await $host.post("web/user/message", { id, message });
  return data;
};

export const deleteCardId = async (id) => {
  const data = await $host.post("web/user/deletecard", { id });
  return data;
};

export const matchPatient = async (userId, phone, birthday, patientId) => {
  const response = await $host.post("web/user/match", { userId, phone, birthday, patientId });
  return response.data;
}
